import type { CardId, ConnectionId, WallConnection, WallId } from '@walls/store/types';
import type { WallsClient } from './client';

export class ConnectionsApi {
  constructor(private readonly client: WallsClient) {}

  getConnections = (boardId: WallId, key?: string | null) => {
    return this.client.requestJson<WallConnection[]>(
      `/boards/connections/${boardId}`,
      boardId,
      key
    );
  };

  insertConnection = (
    boardId: WallId,
    title: string,
    color: string,
    startCardId: CardId,
    endCardId: CardId,
    key?: string | null
  ) => {
    return this.client.requestJson<WallConnection>(`/boards/connections/${boardId}`, boardId, key, {
      method: 'POST',
      body: JSON.stringify({ color, endCardId, startCardId, title }),
    });
  };

  updateConnectionColor = (
    boardId: WallId,
    connectionId: ConnectionId,
    color: string,
    key?: string | null
  ) => {
    return this.client.requestJson<void>(
      `/boards/connections/${boardId}/${connectionId}/color`,
      boardId,
      key,
      {
        method: 'PUT',
        body: JSON.stringify({ color }),
      }
    );
  };

  deleteConnection = (boardId: WallId, connectionId: ConnectionId, key?: string | null) => {
    return this.client.requestJson<void>(
      `/boards/connections/${boardId}/${connectionId}`,
      boardId,
      key,
      {
        method: 'DELETE',
      }
    );
  };
}
